import React, { Component } from 'react';
import { Collapse, Card, CardBody, CardHeader } from 'reactstrap';

class SeoFaq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null,
      showAll: false
    };
  }

  toggleAccordion(index) {
    this.setState(prevState => ({
      activeIndex: prevState.activeIndex === index ? null : index
    }));
  }

  toggleShowAll() {
    this.setState(prevState => ({
      showAll: !prevState.showAll
    }));
  }

  render() {
    const { activeIndex, showAll } = this.state;
    const { faqs } = this.props;
    const visibleFaqs = showAll ? faqs : faqs.slice(0, 3);

    return (
      <div>
        {visibleFaqs.map((faq, index) => (
          <Card key={index} style={{borderBottom: ["46", "62"].includes(faq.id) ? '1px solid #ccc' : 0}}>
            <CardHeader onClick={() => this.toggleAccordion(index)} style={{backgroundColor: 'white', borderBottom: 0}}>
              <h3 className="h6 font-weight-600 d-inline-block mb-0">{faq.question}</h3>
              <i className={`pull-right fa fa-chevron-${activeIndex === index ? 'up' : 'down'}`}/>
            </CardHeader>
            <Collapse isOpen={activeIndex === index}>
              <CardBody>
                <p>{faq.answer}</p>
              </CardBody>
            </Collapse>
          </Card>
        ))}
        {!showAll && faqs.length > 3 && (
          <div className="mt-3 text-right">
            <a href="#" onClick={(e) => { e.preventDefault(); this.toggleShowAll(); }}>{this.props.more_text}</a>
          </div>
        )}
      </div>
    );
  }
}

export default SeoFaq;